export const fakeUser = {
  email: "fake@devslopes.com",
  password: "Devslopes0!",
  cart: undefined,
  shipping: undefined,
  payment: undefined,
  firstName: "Kristine",
  lastName: "Johnson",
  zip: "40241",
};
